"use client";

import { createContext, use } from "react";
import type { LegalDocumentId } from "@/lib/legal/documents";

type LegalContextValue = {
  openDocument: (id: LegalDocumentId) => void;
  openCookiePreferences: () => void;
};

export const LegalContext = createContext<LegalContextValue | null>(null);

/** Null outside <LegalProvider>: callers fall back to plain navigation. */
export const useLegal = () => use(LegalContext);
